
type HashState<TProps extends string[]> = {
    [key in TProps[number]]: string|null
};

export class UrlHashHandler<TProps extends string[]> {
    constructor(private properties: TProps) {}

    public read(): HashState<TProps> {
        const hash = new URLSearchParams(window.location.hash.substring(1));
        const result = {} as HashState<TProps>;

        for (const prop of this.properties) {
            result[prop] = hash.get(prop) || null;
        }

        return result;
    }

    public write(state: HashState<TProps>): void {
        const current = window.location.hash.substring(1);
        // A fragment without parameters is an anchor (for example, #content).
        if (current && !current.includes('=') && !current.includes('&')) {
            return;
        }

        const hash = new URLSearchParams(current);
        for (const prop of this.properties) {
            if (state[prop]) {
                hash.set(prop, state[prop]);
            } else {
                hash.delete(prop);
            }
        }

        const next = hash.toString();
        if (next === current) {
            return;
        }
        if (next) {
            window.location.hash = next;
        } else {
            window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
        }
    }
}
